import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditAirline from "../../components/airlines/Forms/FormAddEditAirline";

const EditAirline = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditAirline isEdit={true} />
        </WrapperSection>
    );
};

export default EditAirline;
